import { api } from './index';
import { omitBy } from 'lodash';
import { isNil } from 'utils';

export default {
  getBrandList(category_id, status) {
    const params = { category_id, status };
    const url = '/brands';
    return api.get(url, { params: omitBy(params, isNil) });
  },
  hideBrand(id) {
    return api.delete(`/brands/${id}`);
  },
  deleteBrand(id) {
    return api.delete(`/brands/${id}/delete`);
  },
  showBrand(id) {
    return api.get(`/brands/${id}`);
  },
  updateBrand(payload) {
    return api.put(`/brands`, { brands: [payload] });
  },
  updateBrandOrder(payload) {
    return api.put(`/brands/update_order`, { brands: payload });
  },
  createBrand(payload) {
    return api.post(`/brands`, { brand: payload });
  },
  restoreBrand(id) {
    return api.put(`/brands/${id}/reactivate`);
  },
  getCategoryList(parentId) {
    if (parentId) {
      return api.get(`/brands/categories?parent_id=${parentId}&status=active&`);
    } else {
      return api.get(`/brands/categories?status=active&`);
    }
  },
};
